import { ReactElement } from 'react'
import Results2ElementList, { Results2ListItem } from '../Results2ElementList'

type Props = {
  items: Results2ListItem[]
  selectedId?: string
  selectedIds?: string[]
  onSelect?: (id: string) => boolean | void
  onSelectionChange?: (ids: string[]) => boolean | void
  isLoading?: boolean
  emptyMessage?: string
  onCalculate?: () => void
  /** Cancels in-flight results loading; surfaced as an "Abbrechen" footer button. */
  onAbort?: () => void
  /** When true, shows the "Abbrechen" button next to "Berechnen". */
  showAbort?: boolean
  fokusCamera: boolean
  onFokusCameraChange: (next: boolean) => void
  fokusTransparency: boolean
  onFokusTransparencyChange: (next: boolean) => void
  disableForm?: boolean
}

const Results2StandardRipsList = ({
  items,
  selectedId,
  selectedIds,
  onSelect,
  onSelectionChange,
  isLoading,
  emptyMessage,
  onCalculate,
  onAbort,
  showAbort = false,
  fokusCamera,
  onFokusCameraChange,
  fokusTransparency,
  onFokusTransparencyChange,
  disableForm = false,
}: Props): ReactElement => {
  return (
    <Results2ElementList
      items={items}
      elementType="standard_rips"
      selectedId={selectedId}
      selectedIds={selectedIds}
      onSelect={onSelect}
      onSelectionChange={onSelectionChange}
      multiSelectEnabled={false}
      groupingEnabled={false}
      isLoading={isLoading}
      emptyMessage={emptyMessage}
      showBlockpadButton={false}
      onCalculate={onCalculate}
      onAbort={onAbort}
      showAbort={showAbort}
      showCommentColumn={false}
      hideExportButton
      fokusCamera={fokusCamera}
      onFokusCameraChange={onFokusCameraChange}
      fokusTransparency={fokusTransparency}
      onFokusTransparencyChange={onFokusTransparencyChange}
      disableForm={disableForm}
    />
  )
}

export default Results2StandardRipsList
